import styled from '@emotion/styled';

import theme from 'theme';
import {SizeTokenValue} from 'common';
import {Loader as BaseLoader} from 'Loader';

import type {PropsWithChildren} from 'common';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${theme.colors.grey[40]};

  ${theme.typography.p1compact};
`;

export const Loader: React.FC<PropsWithChildren> = ({children}) => (
  <Container>
    <BaseLoader size={SizeTokenValue.Small} />
    <div>{children}</div>
  </Container>
);
